<template>
  <header class="header">
    <div class="w-header h-100 d-flex justify-content-between align-items-center">
      <div class="nav-left d-flex align-items-center">
        <div class="logo cursor-pointer">
          <img src="@/assets/images/login/login-logo.png" alt="" @click="goHome" />
        </div>
        <div class="nav-list d-flex align-items-center">
          <div
            :class="['nav-item drop_toggle', firstNavIndex == index ? 'active' : '', selectMenu == item.name ? 'menu_arrow' : '']"
            v-for="(item, index) in navList"
            @mouseover="menuHover(item)"
            @mouseleave="menuLeave"
            :key="index"
          >
            <div class="cursor-pointer item-name" :class="[item.children && item.children.length > 0 ? 'with-children' : '']" @click="changeNav(item, index)">
              {{ item.name }}
              <i class="el-icon-arrow-down" v-show="item.children && item.children.length > 0"></i>
            </div>
            <!-- 产品二级菜单 -->
            <div
              class="nav-second"
              v-if="item.children && item.children.length > 0"
              :class="[item.id, item.children && item.children.length > 0 ? 'with-children' : '']"
            >
              <div class="hidden-block"></div>
              <div class="nav-second-list">
                <div class="nav-second-content" :class="item.id">
                  <div class="d-flex">
                    <div class="nav-second-wrap" v-for="(secondItem, secondIndex) in item.children" :key="secondIndex">
                      <!-- 产品三级菜单 -->
                      <div class="nav-third" v-if="secondItem.children && item.id == 'products'">
                        <div class="product-top w-100">
                          <div class="left-title">
                            Product
                          </div>
                          <div class="right-stage d-flex align-items-center justify-content-between">
                            <div class="start">
                              Prospecting
                              <i class="el-icon-right"></i>
                            </div>
                            <div class="stage-item" :class="[selectStage == 0 ? 'active' : '']" @mouseover="stageHover(0)">
                              Lead
                              <i class="el-icon-right"></i>
                            </div>
                            <div class="stage-item" :class="[selectStage == 1 ? 'active' : '']" @mouseover="stageHover(1)">
                              Qualification
                              <i class="el-icon-right"></i>
                            </div>
                            <div class="stage-item" :class="[selectStage == 2 ? 'active' : '']" @mouseover="stageHover(2)">
                              Engagement
                              <i class="el-icon-right"></i>
                            </div>
                            <div class="stage-item" :class="[selectStage == 3 ? 'active' : '']" @mouseover="stageHover(3)">
                              Demo
                              <i class="el-icon-right"></i>
                            </div>
                            <div class="stage-item" :class="[selectStage == 4 ? 'active' : '']" @mouseover="stageHover(4)">
                              Proposal
                              <i class="el-icon-right"></i>
                            </div>
                            <div class="stage-item" :class="[selectStage == 5 ? 'active' : '']" @mouseover="stageHover(5)">
                              Negotiation and commitment
                              <i class="el-icon-right"></i>
                            </div>
                            <div class="end">
                              Win
                            </div>
                          </div>
                        </div>
                        <div class="product-wrap d-flex">
                          <div class="product-left">
                            <div
                              v-for="(thirdItem, thirdIndex) in secondItem.children.slice(0, 1)"
                              :key="thirdIndex"
                              class="nav-third-item d-flex align-items-center justify-content-between cursor-pointer"
                              :class="[thirdItem.class, thirdItem.routerPath == $route.path ? 'selected' : '']"
                              @click="handleThirdClickNew(thirdItem, thirdIndex)"
                            >
                              <div class="w-100 item-name d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center">
                                  <img :src="thirdItem.icon" :class="thirdItem.imgClass" alt="" />
                                  <div class="text-wrap">
                                    <div class="label">
                                      {{ thirdItem.name }}
                                    </div>
                                    <div class="desc">
                                      {{ thirdItem.desc }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="product-right">
                            <div class="right-col">
                              <div
                                v-for="(thirdItem, thirdIndex) in secondItem.children.slice(1, 4)"
                                :key="thirdIndex"
                                class="nav-third-item d-flex align-items-center justify-content-between cursor-pointer"
                                :class="[thirdItem.class, activeProduct.indexOf(thirdItem.routerPath) > -1 ? 'selected' : '']"
                                @mouseover="thirdNavHover(thirdItem)"
                                @click="handleThirdClickNew(thirdItem, thirdIndex)"
                              >
                                <div class="w-100 item-name d-flex align-items-center justify-content-between">
                                  <div class="d-flex align-items-center">
                                    <img :src="thirdItem.icon" :class="thirdItem.imgClass" alt="" />
                                    <div class="text-wrap">
                                      <div class="label">
                                        {{ thirdItem.name }}
                                      </div>
                                      <div class="desc">
                                        {{ thirdItem.desc }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="right-col">
                              <div
                                v-for="(thirdItem, thirdIndex) in secondItem.children.slice(4, 7)"
                                :key="thirdIndex"
                                class="nav-third-item d-flex align-items-center justify-content-between cursor-pointer"
                                :class="[thirdItem.class, activeProduct.indexOf(thirdItem.routerPath) > -1 ? 'selected' : '']"
                                @mouseover="thirdNavHover(thirdItem)"
                                @click="handleThirdClickNew(thirdItem, thirdIndex)"
                              >
                                <div class="w-100 item-name d-flex align-items-center justify-content-between">
                                  <div class="d-flex align-items-center">
                                    <img :src="thirdItem.icon" :class="thirdItem.imgClass" alt="" />
                                    <div class="text-wrap">
                                      <div class="label">
                                        {{ thirdItem.name }}
                                      </div>
                                      <div class="desc">
                                        {{ thirdItem.desc }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="right-col">
                              <div
                                v-for="(thirdItem, thirdIndex) in secondItem.children.slice(7, 9)"
                                :key="thirdIndex"
                                class="nav-third-item d-flex align-items-center justify-content-between cursor-pointer"
                                :class="[thirdItem.class, activeProduct.indexOf(thirdItem.routerPath) > -1 ? 'selected' : '']"
                                @mouseover="thirdNavHover(thirdItem)"
                                @click="handleThirdClickNew(thirdItem, thirdIndex)"
                              >
                                <div class="w-100 item-name d-flex align-items-center justify-content-between">
                                  <div class="d-flex align-items-center">
                                    <img :src="thirdItem.icon" :class="thirdItem.imgClass" alt="" />
                                    <div class="text-wrap">
                                      <div class="label">
                                        {{ thirdItem.name }}
                                      </div>
                                      <div class="desc">
                                        {{ thirdItem.desc }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- <div
                          v-for="(thirdItem, thirdIndex) in secondItem.children"
                          :key="thirdIndex"
                          class="nav-third-item d-flex align-items-center justify-content-between cursor-pointer"
                          :class="[thirdItem.class, thirdItem.routerPath == $route.path ? 'selected' : '']"
                          @click="handleThirdClick(secondItem, thirdIndex)"
                        >
                          <div class="w-100 item-name d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center">
                              <img :src="thirdItem.icon" :class="thirdItem.imgClass" alt="" />
                              <div class="text-wrap">
                                <div class="label">
                                  {{ thirdItem.name }}
                                </div>
                                <div class="desc">
                                  {{ thirdItem.desc }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="nav-third-item-children" v-if="thirdItem.children">
                            <div
                              v-for="(fourthItem, fourthIndex) in thirdItem.children"
                              :key="fourthIndex"
                              class="nav-third-item-children-item d-flex align-center"
                            >
                              <div class="mr-1">
                                <img :src="fourthItem.icon" alt="" />
                              </div>
                              <div class="cursor-pointer item-name">
                                {{ fourthItem.name }}
                              </div>
                            </div>
                          </div>
                        </div> -->
                      </div>

                      <!-- 方案三级菜单 -->
                      <template v-if="secondItem.children && item.id == 'solutions'">
                        <!-- <template> -->
                        <div class="nav-second-item w-100">
                          <div>
                            <div class="item-name">
                              <span>{{ secondItem.name }}</span>
                            </div>
                          </div>
                          <i class="el-icon-arrow-right nav-second-item-arrow" v-if="secondItem.children"></i>
                        </div>
                        <div class="nav-third">
                          <div
                            v-for="(thirdItem, thirdIndex) in secondItem.children"
                            :key="thirdIndex"
                            class="nav-third-item d-flex align-items-center justify-content-between cursor-pointer"
                            :class="[thirdItem.class, thirdItem.routerPath == $route.path ? 'selected' : '']"
                            @click="handleThirdClick(secondItem, thirdIndex)"
                          >
                            <div class="w-100 item-name d-flex align-items-center justify-content-between">
                              <div class="d-flex align-items-center">
                                <img :src="thirdItem.icon" :class="thirdItem.imgClass" alt="" />
                                <div class="text-wrap">
                                  <div class="label">
                                    {{ thirdItem.name }}
                                  </div>
                                  <div class="desc">
                                    {{ thirdItem.desc }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>

                      <!-- 资源三级菜单 -->
                      <template v-if="item.id == 'resources'">
                        <div class="nav-second-item w-100">
                          <div>
                            <div class="item-name text-left">
                              <span>{{ secondItem.name }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="nav-third-wrap d-flex" v-if="secondItem.id == 'problems'">
                          <div class="nav-third">
                            <div
                              v-for="(thirdItem, thirdIndex) in secondItem.children1"
                              :key="thirdIndex"
                              class="nav-third-item d-flex align-items-center justify-content-between cursor-pointer"
                              :class="[thirdItem.class, thirdItem.routerPath == $route.path ? 'selected' : '']"
                              @click="handleThirdClickNew(thirdItem)"
                            >
                              <div class="w-100 item-name d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center">
                                  <img :src="thirdItem.icon" :class="thirdItem.imgClass" alt="" />
                                  <div class="text-wrap">
                                    <div class="label" :class="thirdItem.labelClass">
                                      {{ thirdItem.name }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="nav-third">
                            <div
                              v-for="(thirdItem, thirdIndex) in secondItem.children2"
                              :key="thirdIndex"
                              class="nav-third-item d-flex align-items-center justify-content-between cursor-pointer"
                              :class="[thirdItem.class, thirdItem.routerPath == $route.path ? 'selected' : '']"
                              @click="handleThirdClickNew(thirdItem)"
                            >
                              <div class="w-100 item-name d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center">
                                  <img :src="thirdItem.icon" :class="thirdItem.imgClass" alt="" />
                                  <div class="text-wrap">
                                    <div class="label">
                                      {{ thirdItem.name }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="nav-third">
                            <div
                              v-for="(thirdItem, thirdIndex) in secondItem.children3"
                              :key="thirdIndex"
                              class="nav-third-item d-flex align-items-center justify-content-between cursor-pointer"
                              :class="[thirdItem.class, thirdItem.routerPath == $route.path ? 'selected' : '']"
                              @click="handleThirdClickNew(thirdItem)"
                            >
                              <div class="w-100 item-name d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center">
                                  <img :src="thirdItem.icon" :class="thirdItem.imgClass" alt="" />
                                  <div class="text-wrap">
                                    <div class="label">
                                      {{ thirdItem.name }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="nav-third-wrap" v-else>
                          <div class="nav-third d-block">
                            <div
                              v-for="(thirdItem, thirdIndex) in secondItem.children"
                              :key="thirdIndex"
                              class="nav-third-item d-flex align-items-center justify-content-between cursor-pointer"
                              :class="[thirdItem.class, thirdItem.routerPath == $route.path ? 'selected' : '']"
                              @click="handleThirdClick(secondItem, thirdIndex)"
                            >
                              <div class="w-100 item-name d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center">
                                  <img :src="thirdItem.icon" :class="thirdItem.imgClass" alt="" />
                                  <div class="text-wrap">
                                    <div class="label">
                                      {{ thirdItem.name }}
                                    </div>
                                    <div class="desc">
                                      {{ thirdItem.desc }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>

                      <!-- 公司三级菜单 -->
                      <template v-if="secondItem.children && item.id == 'company'">
                        <div class="nav-second-item w-100">
                          <div>
                            <div class="item-name">
                              <span>{{ secondItem.name }}</span>
                            </div>
                          </div>
                          <i class="el-icon-arrow-right nav-second-item-arrow" v-if="secondItem.children"></i>
                        </div>
                        <div class="nav-third">
                          <div
                            v-for="(thirdItem, thirdIndex) in secondItem.children"
                            :key="thirdIndex"
                            class="nav-third-item d-flex align-items-center justify-content-between cursor-pointer"
                            :class="[thirdItem.class, thirdItem.routerPath == $route.path ? 'selected' : '']"
                            @click="handleThirdClick(secondItem, thirdIndex)"
                          >
                            <div class="w-100 item-name d-flex align-items-center justify-content-between">
                              <div class="d-flex align-items-center">
                                <img :src="thirdItem.icon" :class="thirdItem.imgClass" alt="" />
                                <div class="text-wrap">
                                  <div class="label">
                                    {{ thirdItem.name }}
                                  </div>
                                  <div class="desc">
                                    {{ thirdItem.desc }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="join d-flex justify-content-between align-items-center">
                    <div class="left-content d-flex align-items-center">
                      <img src="@/assets/images/header/join-icon.png" alt="" />
                      Want Qualified Leads? Try Xpirory AI Tools Free.
                    </div>
                    <el-button type="primary" @click="jumpRoute('/contact')">
                      Free Trial
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="nav-list-mobile">
        <div class="icon-wrap">
          <img v-if="mobileMenuShow == false" @click="toggleMobileMenu" src="@/assets/images/header/open.svg" class="menu" alt="" />
          <img v-if="mobileMenuShow == true" @click="toggleMobileMenu" src="@/assets/images/header/close.svg" class="menu-off" alt="" />
        </div>
      </div>
      <div class="nav-right d-flex align-items-center">
        <template>
          <div class="loginBtn cursor-pointer" @click="goLogin" v-if="!userName">
            <!-- 立即登录 -->
            {{ $t('message.header.loginBtn') }}
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="loginBtn cursor-pointer" @click="goLoginOut" v-else>
            <!-- 退出登录 -->
            {{ $t('message.header.loginOutBtn') }}
          </div>
        </template>
        <el-button type="primary" class="special" @click="jumpRoute('/contact')">
          Free Trial
        </el-button>
        <!-- 中英文切换 -->
        <!-- <el-dropdown>
          <span class="loginBtn cursor-pointer">
            {{ currentLangLabel }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(lang, index) in langList" :key="index">
              <div @click="changeLanguage(lang)" class="cursor-pointer" :class="lang.code == currentLang ? 'active' : ''">
                {{ lang.label }}
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
      </div>
    </div>
    <div class="mobile-menu" v-if="mobileMenuShow">
      <div :class="['nav-item', firstNavIndex == index ? 'active' : '']" v-for="(item, index) in navList" :key="index">
        <div
          class="cursor-pointer item-name d-flex align-items-center justify-content-between drop_toggle"
          :class="[selectFirstMobileMenu == item.name ? 'menu_arrow' : '']"
          @click="changeFirstMobile(item, index)"
        >
          <div>
            {{ item.name }}
          </div>
          <i class="el-icon-arrow-down nav-second-item-arrow" v-if="item.children"></i>
        </div>
        <el-collapse-transition>
          <!-- 二级菜单 -->
          <div v-if="item.children && selectFirstMobileMenu == item.name" class="nav-second">
            <div class="nav-second-list">
              <div v-for="(secondItem, secondIndex) in item.children" :key="secondIndex">
                <div
                  class="nav-second-item cursor-pointer d-flex align-items-center justify-content-between drop_toggle"
                  :class="[secondNavIndex == secondIndex ? 'active' : '', selectMobileMenu == secondItem.name ? 'menu_arrow' : '']"
                  @click="changeSecondMobile(secondItem, index, secondIndex)"
                  v-if="item.id != 'products' && item.id != 'company'"
                >
                  <div class="d-flex align-items-center">
                    <div class="item-name">
                      {{ secondItem.name }}
                    </div>
                  </div>
                  <i class="el-icon-arrow-down nav-second-item-arrow" v-if="secondItem.children || secondItem.children1"></i>
                </div>

                <!-- 三级菜单 -->
                <div class="nav-third" v-if="secondItem.children && (item.id == 'products' || item.id == 'company')">
                  <div
                    v-for="(thirdItem, thirdIndex) in secondItem.children"
                    :key="thirdIndex"
                    class="nav-third-item"
                    :class="[
                      secondItem.id == 'developTools' && (thirdIndex == 1 || thirdIndex == 4) ? 'special' : '',
                      secondItem.id == 'supportTools' && (thirdIndex == 0 || thirdIndex == 2) ? 'special2' : '',
                      secondItem.id == 'supportTools' && (thirdIndex == 1 || thirdIndex == 3) ? 'special3' : '',
                    ]"
                  >
                    <div class="item-name" @click="handleThirdClick(secondItem, thirdIndex)">
                      {{ thirdItem.name }}
                    </div>
                  </div>
                </div>
                <el-collapse-transition>
                  <!-- 三级菜单 -->
                  <div class="nav-third" v-if="secondItem.children && secondItem.id != 'problems' && selectMobileMenu == secondItem.name">
                    <div
                      v-for="(thirdItem, thirdIndex) in secondItem.children"
                      :key="thirdIndex"
                      class="nav-third-item"
                      :class="[
                        secondItem.id == 'developTools' && (thirdIndex == 1 || thirdIndex == 4) ? 'special' : '',
                        secondItem.id == 'supportTools' && (thirdIndex == 0 || thirdIndex == 2) ? 'special2' : '',
                        secondItem.id == 'supportTools' && (thirdIndex == 1 || thirdIndex == 3) ? 'special3' : '',
                      ]"
                    >
                      <div class="item-name" @click="handleThirdClick(secondItem, thirdIndex)">
                        {{ thirdItem.name }}
                      </div>
                      <!-- 产品四级菜单 -->
                      <div class="nav-third-item-children" v-if="thirdItem.children">
                        <div
                          v-for="(fourthItem, fourthIndex) in thirdItem.children"
                          :key="fourthIndex"
                          class="nav-third-item-children-item d-flex align-center"
                        >
                          <div class="mr-1">
                            <img :src="fourthItem.icon" alt="" />
                          </div>
                          <div class="cursor-pointer item-name">
                            {{ fourthItem.name }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 三级菜单 -->
                  <div class="nav-third" v-if="secondItem.id == 'problems' && selectMobileMenu == secondItem.name">
                    <div
                      v-for="(thirdItem, thirdIndex) in secondItem.children1.concat(secondItem.children2.concat(secondItem.children3))"
                      :key="thirdIndex"
                      class="nav-third-item"
                      :class="[
                        secondItem.id == 'developTools' && (thirdIndex == 1 || thirdIndex == 4) ? 'special' : '',
                        secondItem.id == 'supportTools' && (thirdIndex == 0 || thirdIndex == 2) ? 'special2' : '',
                        secondItem.id == 'supportTools' && (thirdIndex == 1 || thirdIndex == 3) ? 'special3' : '',
                      ]"
                    >
                      <div class="item-name" @click="handleThirdClickNew(thirdItem)">
                        {{ thirdItem.name }}
                      </div>
                      <!-- 产品四级菜单 -->
                      <div class="nav-third-item-children" v-if="thirdItem.children">
                        <div
                          v-for="(fourthItem, fourthIndex) in thirdItem.children"
                          :key="fourthIndex"
                          class="nav-third-item-children-item d-flex align-center"
                        >
                          <div class="mr-1">
                            <img :src="fourthItem.icon" alt="" />
                          </div>
                          <div class="cursor-pointer item-name">
                            {{ fourthItem.name }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 三级菜单 -->
                  <!-- <div class="nav-third" v-else>
                    <div
                      v-for="(thirdItem, thirdIndex) in secondItem.children"
                      :key="thirdIndex"
                      class="nav-third-item"
                      :class="[
                        secondItem.id == 'developTools' && (thirdIndex == 1 || thirdIndex == 4) ? 'special' : '',
                        secondItem.id == 'supportTools' && (thirdIndex == 0 || thirdIndex == 2) ? 'special2' : '',
                        secondItem.id == 'supportTools' && (thirdIndex == 1 || thirdIndex == 3) ? 'special3' : '',
                      ]"
                    >
                      <div class="item-name" @click="handleThirdClick(secondItem, thirdIndex)">
                        {{ thirdItem.name }}
                      </div>
                      <div class="nav-third-item-children" v-if="thirdItem.children">
                        <div v-for="(fourthItem, fourthIndex) in thirdItem.children" :key="fourthIndex" class="nav-third-item-children-item d-flex align-center">
                          <div class="mr-1">
                            <img :src="fourthItem.icon" alt="" />
                          </div>
                          <div class="cursor-pointer item-name">
                            {{ fourthItem.name }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </el-collapse-transition>
              </div>
            </div>
          </div>
        </el-collapse-transition>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderComponent',
  props: ['currentLang'],
  inject: ['changeAppLanguage'],
  data() {
    return {
      activeStage: -1,
      selectPlatform: [],
      hoverPlatform: '',
      stageData: [
        {
          label: this.$t('message.header.stageText2'),
          icon: require('@/assets/images/header/stage1.png'),
          imgClass: 'stage-icon0',
        },
        {
          label: this.$t('message.header.stageText3'),
          icon: require('@/assets/images/header/stage2.png'),
          imgClass: 'stage-icon1',
        },
        {
          label: this.$t('message.header.stageText4'),
          icon: require('@/assets/images/header/stage3.png'),
          imgClass: 'stage-icon2',
        },
        // {
        //   label: this.$t('message.header.stageText5'),
        //   icon: require('@/assets/images/header/stage4.png'),
        //   imgClass: 'stage-icon3',
        // },
        {
          label: this.$t('message.header.stageText6'),
          icon: require('@/assets/images/header/stage5.png'),
          imgClass: 'stage-icon4',
        },
        {
          label: this.$t('message.header.stageText7'),
          icon: require('@/assets/images/header/stage6.png'),
          imgClass: 'stage-icon5',
        },
        {
          label: this.$t('message.header.stageText8'),
          icon: require('@/assets/images/header/stage7.png'),
          imgClass: 'stage-icon6',
        },
      ],
      userName: localStorage.user_name,
      firstNavIndex: -1, // 当前选中的导航索引
      navList: [
        {
          id: 'products',
          name: this.$t('message.header.navList[0].name'), // 产品
          routerPath: '',
          children: [
            {
              id: 'developTools',
              icon: require('@/assets/images/header/product-icon8.png'),
              name: 'Product', // 业务开拓工具
              routerPath: '/developTools',
              pid: 'products',
              children: [
                {
                  name: 'Opportunity Workspace',
                  icon: require('@/assets/images/header/solution-icon10.svg'),
                  desc: 'Make B2B Sales Process Management Simpler',
                  routerPath: '/businessOpportunity',
                },
                {
                  name: 'AI Prospecting Agent',
                  icon: require('@/assets/images/header/product-icon0.svg'),
                  desc: 'Automatically Find, Analyze, Qualify, and Engage High-Fit Prospects',
                  routerPath: '/aiProspecting',
                },
                {
                  name: 'Customer Deep Insight',
                  icon: require('@/assets/images/header/solution-icon1.svg'),
                  desc: 'Accurately Pinpoint Customer Needs and Pain Points',
                  routerPath: '/customerAnalysis',
                },
                {
                  name: this.$t('message.header.navList[0].children[1].children[6].name'), // 困境策略大师
                  icon: require('@/assets/images/header/solution-icon4.svg'),
                  desc: 'Navigate Sales Challenges',
                  routerPath: '/strategyCoach',
                },
                {
                  name: this.$t('message.header.navList[0].children[1].children[3].name'), // 图文海报制作
                  icon: require('@/assets/images/header/solution-icon6.svg'),
                  desc: 'Create Posters in Any Language',
                  routerPath: '/smartPoster',
                },
                {
                  name: 'Pain Point Discovery', // 痛点挖掘
                  icon: require('@/assets/images/header/solution-icon2.svg'),
                  desc: 'Target the Key Pain Points',
                  routerPath: '/painPoints',
                },
                {
                  name: 'Operation Simulation and Analysis', // 运营模拟分析
                  icon: require('@/assets/images/header/solution-icon5.svg'),
                  desc: 'Quantify Decision Impact',
                  routerPath: '/simulation',
                },
                {
                  name: 'Solution Generation', // 方案生成
                  icon: require('@/assets/images/header/solution-icon7.svg'),
                  desc: 'Generate Tailored Solutions',
                  routerPath: '/solutionGenerationPlatform',
                },
                {
                  name: 'Demo & Training', // Demo及培训平台
                  icon: require('@/assets/images/header/solution-icon3.svg'),
                  desc: 'Remote Immersive Demo',
                  routerPath: '/training',
                },
              ],
            },
          ],
        },
        {
          id: 'solutions',
          name: 'Solutions',
          routerPath: '',
          children: [
            {
              id: 'role',
              name: 'BY ROLE',
              routerPath: '',
              pid: 'roleId',
              children: [
                {
                  platformIndex: 0,
                  name: 'Sales Teams',
                  icon: require('@/assets/images/header/solution-icon1.svg'),
                  desc: 'The Smart Way to Sell, the Fast Way to Close.',
                  routerPath: '/saleTeams',
                },
                {
                  platformIndex: 1,
                  name: 'Pre-Sales / Consultants',
                  icon: require('@/assets/images/header/solution-icon2.svg'),
                  desc: 'Clone Your Best Sales Engineer.',
                  routerPath: '/preSaleTeams',
                },
                {
                  platformIndex: 2,
                  name: 'Partners / Distributors',
                  icon: require('@/assets/images/header/solution-icon3.svg'),
                  desc: 'Empower Partners to Sell More Effectively.',
                  routerPath: '/partners',
                },
              ],
            },
            {
              id: 'industry',
              name: 'BY INDUSTRY',
              routerPath: '',
              pid: 'roleId',
              children: [
                {
                  name: 'Manufacturing & Industrial',
                  icon: require('@/assets/images/header/solution-icon4.svg'),
                  desc: 'Simplify complex equipment sales.',
                  routerPath: '/manufacturing',
                },
                {
                  name: 'Software & IT Services',
                  icon: require('@/assets/images/header/solution-icon5.svg'),
                  desc: 'Tailor solutions, close faster.',
                  routerPath: '/software',
                },
                {
                  name: 'Automation / Robotics',
                  icon: require('@/assets/images/header/solution-icon6.svg'),
                  desc: 'Demonstrate ROI and efficiency.',
                  routerPath: '/automation',
                },
                {
                  name: 'Logistics & Operations Services',
                  icon: require('@/assets/images/header/solution-icon7.svg'),
                  desc: 'Visualize network optimization.',
                  routerPath: '/logistics',
                },
                {
                  name: 'Engineering & Construction',
                  icon: require('@/assets/images/header/solution-icon8.svg'),
                  desc: 'Win large-scale project bids.',
                  routerPath: '/engineering',
                },
                {
                  name: 'Green Energy / New Energy',
                  icon: require('@/assets/images/header/solution-icon9.svg'),
                  desc: 'Accelerate sustainable projects.',
                  routerPath: '/energy',
                },
              ],
            },
          ],
        },
        {
          id: 'resources',
          name: 'Resources',
          routerPath: '',
          children: [
            {
              id: 'problems',
              name: 'PROBLEMS WE SOLVE',
              routerPath: '',
              pid: 'problemsId',
              children1: [
                {
                  name: 'Difficulty Finding High-Fit Prospects?',
                  icon: require('@/assets/images/header/solution-icon1.svg'),
                  routerPath: '/findingProspects',
                  labelClass: 'special',
                },
                {
                  name: 'Stalled Sales Opportunities?',
                  icon: require('@/assets/images/header/solution-icon9.svg'),
                  routerPath: '/salesOpportunities',
                },
                {
                  name: 'Handling Competitive Threats?',
                  icon: require('@/assets/images/header/solution-icon3.svg'),
                  routerPath: '/handlingThreats',
                },
                
                
                
                {
                  name: 'Establishing Professional Credibility?',
                  icon: require('@/assets/images/header/solution-icon4.svg'),
                  routerPath: '/credibility',
                },
              ],
              children2: [
                {
                  name: 'Lack of Client Insight?',
                  icon: require('@/assets/images/header/solution-icon1.svg'),
                  routerPath: '/clientInsight',
                },
                {
                  name: 'Unclear Client Requirements?',
                  icon: require('@/assets/images/header/solution-icon2.svg'),
                  routerPath: '/unclearRequirements',
                },
                {
                  name: 'Rapid Onboarding & Enablement?',
                  icon: require('@/assets/images/header/solution-icon3.svg'),
                  routerPath: '/enablement',
                },
                
                
                {
                  name: 'High Product Demo Costs?',
                  icon: require('@/assets/images/header/solution-icon5.svg'),
                  routerPath: '/demoCosts',
                },
              ],
              children3: [
                {
                  name: 'Handling Client Objections?',
                  icon: require('@/assets/images/header/solution-icon8.svg'),
                  routerPath: '/handlingObjections',
                },
                {
                  name: 'Managing Multiple Client Demands?',
                  icon: require('@/assets/images/header/solution-icon7.svg'),
                  routerPath: '/managingDemands',
                },
                {
                  name: 'Reducing Sales Travel Costs?',
                  icon: require('@/assets/images/header/solution-icon6.svg'),
                  routerPath: '/reducingCosts',
                },
                
              ],
            },
            {
              id: 'knowledge',
              name: 'KNOWLEDGE HUB',
              routerPath: '',
              pid: 'knowledgeId',
              children: [
                {
                  platformIndex: 0,
                  name: 'Guides & Tutorials',
                  icon: require('@/assets/images/header/solution-icon4.svg'),
                  desc: 'Learn how to use our tools effectively.',
                  routerPath: '',
                },
                {
                  platformIndex: 3,
                  name: 'Case Studies',
                  icon: require('@/assets/images/header/solution-icon5.svg'),
                  desc: 'See our solutions in action.',
                  routerPath: '',
                },
              ],
            },
          ],
        },
        {
          id: 'pricing',
          name: 'Pricing',
          routerPath: '/pricing',
        },
        {
          id: 'company',
          name: 'Company',
          routerPath: '',
          children: [
            {
              id: 'companyChild',
              icon: require('@/assets/images/header/product-icon8.png'),
              name: 'Company',
              routerPath: '',
              pid: 'companyChildId',
              children: [
                {
                  name: 'About us',
                  icon: require('@/assets/images/header/company-icon1.svg'),
                  desc: 'See How We Power AI-Driven Lead Generation',
                  routerPath: '/about',
                },
                {
                  name: 'Contact us',
                  icon: require('@/assets/images/header/company-icon2.svg'),
                  desc: `We're excited to help & eager to hear from you`,
                  routerPath: '/contact',
                },
                // {
                //   name: 'FAQ',
                //   icon: require('@/assets/images/header/company-icon3.svg'),
                //   desc: 'Frequently Asked Questions',
                //   routerPath: '/faq',
                // },
              ],
            },
          ],
        },
        {
          id: 'faq',
          name: 'FAQ',
          routerPath: '/faq',
        },
      ],
      secondNavIndex: -1, // 二级导航索引
      langList: [
        {
          code: 'cn',
          label: '简体中文',
        },
        {
          code: 'en',
          label: 'English',
        },
      ],
      currentLangLabel: '',
      hostName: '',
      mobileMenuShow: false,

      selectMenu: '',
      selectFirstMobileMenu: 'Products',
      selectMobileMenu: '',

      selectStage: '',
      activeProduct: [],
    };
  },
  watch: {
    $route: {
      handler(to, from) {
        // console.log('参数变化:', to);
        localStorage.setItem('firstNavIndex', to.meta.index);
        this.$nextTick(() => {
          this.firstNavIndex = localStorage.getItem('firstNavIndex') || -1;
        });
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.hostName = location.host.substring(location.host.lastIndexOf('.'));
    this.currentLangLabel = this.langList.find(item => item.code == this.currentLang).label || '简体中文';
    this.secondNavIndex = localStorage.getItem('secondNavIndex') || -1;
    if (this.$route.path == '/') {
      localStorage.setItem('firstNavIndex', -1);
    }
    this.$nextTick(() => {
      this.firstNavIndex = localStorage.getItem('firstNavIndex') || -1;
    });
  },
  methods: {
    thirdNavHover(thirdData) {
      if(thirdData.routerPath == '/customerAnalysis' || thirdData.routerPath == '/painPoints') {
        this.stageHover(1);
      } else if(thirdData.routerPath == '/strategyCoach' || thirdData.routerPath == '/smartPoster') {
        this.stageHover(2);
      } else if(thirdData.routerPath == '/training') {
        this.stageHover(3);
      } else if(thirdData.routerPath == '/simulation' || thirdData.routerPath == '/solutionGenerationPlatform') {
        this.stageHover(4);
      } else if(thirdData.routerPath == '/strategyCoach') {
        this.stageHover(5);
      } else if(thirdData.routerPath == '/aiProspecting') {
        this.stageHover(0);
      }
    },
    stageHover(flag) {
      this.selectStage = flag;
      switch (flag) {
        case 0:
          this.activeProduct = ['/aiProspecting'];
          break;

        case 1:
          this.activeProduct = ['/customerAnalysis', '/painPoints'];
          break;

        case 2:
          this.activeProduct = ['/strategyCoach', '/smartPoster'];
          break;

        case 3:
          this.activeProduct = ['/training'];
          break;

        case 4:
          this.activeProduct = ['/simulation', '/solutionGenerationPlatform'];
          break;

        case 5:
          this.activeProduct = ['/strategyCoach'];
          break;
      
        default:
          break;
      }
    },
    menuHover(data) {
      this.selectMenu = data.name;
    },
    menuLeave() {
      this.selectMenu = '';
    },
    toggleMobileMenu() {
      this.mobileMenuShow = !this.mobileMenuShow;
    },
    changeFirstNavIndex(index) {
      this.firstNavIndex = index;
    },
    // 跳转首页
    goHome() {
      this.firstNavIndex = -1;
      this.secondNavIndex = -1;
      localStorage.removeItem('firstNavIndex');
      localStorage.removeItem('secondNavIndex');
      this.$router.push('/');
    },

    // 中英文切换
    changeLanguage(lang) {
      // return;
      this.currentLangLabel = this.langList.find(item => item.code == lang.code).label || '简体中文';
      this.changeAppLanguage(lang.code);
    },

    // 登录
    goLogin() {
      window.location.href =
        process.env.NODE_ENV === 'development'
          ? `https://user.xpirory.ai/login?lang=${this.currentLang == 'cn' ? 'zh' : this.currentLang}`
          : `https://user.xpirory.ai/login?lang=${this.currentLang == 'cn' ? 'zh' : this.currentLang}`;
      localStorage.clear();
    },

    // 退出登录
    goLoginOut() {
      this.$confirm(this.$t('message.index.logoutTips'), this.$t('message.tips'), {
        type: 'warning',
      }).then(() => {
        this.$message.success(this.$t('message.index.logoutSuccess'));
        localStorage.clear();
      });
    },

    // 导航
    changeNav(item, index, secondIndex) {
      if (item.id == 'docs') {
        this.goLogin();
        return;
      }
      if (item.id == 'procucts') {
        return;
      }
      this.firstNavIndex = index;
      localStorage.setItem('firstNavIndex', index);
      if (secondIndex !== undefined) {
        this.secondNavIndex = secondIndex;
        localStorage.setItem('secondNavIndex', secondIndex);
      } else {
        this.secondNavIndex = -1;
        localStorage.setItem('secondNavIndex', -1);
      }
      if (item.routerPath) {
        this.$router.push(item.routerPath);
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
      this.mobileMenuShow = false;
    },

    changeFirstMobile(item, index) {
      if (item.id == 'pricing') {
        this.$router.push('/pricing');
        return;
      }
      if (item.name == this.selectFirstMobileMenu) {
        this.selectFirstMobileMenu = '';
        return;
      }
      this.selectFirstMobileMenu = item.name;
    },

    changeSecondMobile(item, index, secondIndex) {
      if (item.name == this.selectMobileMenu) {
        this.selectMobileMenu = '';
        return;
      }
      this.selectMobileMenu = item.name;
    },

    onStageOver(index) {
      this.activeStage = index;
      this.selectPlatform = [];
      if (index == 0) {
        this.selectPlatform = [0];
      } else if (index == 1) {
        this.selectPlatform = [1, 2];
      } else if (index == 2) {
        this.selectPlatform = [3, 5, 6];
      } else if (index == 3) {
        this.selectPlatform = [7, 9];
      } else if (index == 4) {
        this.selectPlatform = [8];
      } else if (index == 5) {
        this.selectPlatform = [9, 10];
      }
    },
    // 鼠标移入
    onSecondMouseOver(index) {
      this.secondNavIndex = index;
    },
    handleThirdHover(thirdItem) {
      this.hoverPlatform = thirdItem.platformIndex;
      if (thirdItem.platformIndex == 0) {
        this.activeStage = 0;
      } else if (thirdItem.platformIndex == 1 || thirdItem.platformIndex == 2) {
        this.activeStage = 1;
      } else if (thirdItem.platformIndex == 3 || thirdItem.platformIndex == 5 || thirdItem.platformIndex == 6) {
        this.activeStage = 2;
      } else if (thirdItem.platformIndex == 7 || thirdItem.platformIndex == 9) {
        this.activeStage = 3;
      } else if (thirdItem.platformIndex == 8) {
        this.activeStage = 4;
      } else if (thirdItem.platformIndex == 9 || thirdItem.platformIndex == 10) {
        this.activeStage = 5;
      }

      if (this.activeStage == 0) {
        this.selectPlatform = [0];
      } else if (this.activeStage == 1) {
        this.selectPlatform = [1, 2];
      } else if (this.activeStage == 2) {
        this.selectPlatform = [3, 5, 6];
      } else if (this.activeStage == 3) {
        this.selectPlatform = [7, 9];
      } else if (this.activeStage == 4) {
        this.selectPlatform = [8];
      } else if (this.activeStage == 5) {
        this.selectPlatform = [9, 10];
      }
    },
    handleThirdLeave() {
      this.hoverPlatform = '';
    },
    // 三级目录点击
    handleThirdClick(item, index) {
      if (item.children[index].routerPath) {
        this.$router.push(`${item.children[index].routerPath}`);
      }
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      this.mobileMenuShow = false;
    },
    handleThirdClickNew(data) {
      this.$router.push(`${data.routerPath}`);
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      this.mobileMenuShow = false;
    },
    jumpRoute(data) {
      this.$router.push(`${data}`);
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.w-header {
  width: 100%;
  // margin: 0 auto;
  padding: 0 90px;
}

.hidden-block {
  height: 10px;
  background: transparent;
}

.header {
  height: 60px;
  border-bottom: 1px solid #f1f1f1;
  font-size: 14px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000; /* 确保头部层级最高 */
  background: var(--background-color);

  .el-button {
    background-color: #1a65ff;
    padding: 8px 15px;
    border-radius: 8px;
    font-size: 16px;
  }

  .logo img {
    height: 38px;
  }

  .nav-left {
    // position: relative;

    .nav-list {
      margin-left: 65px;
      gap: 42px;

      .nav-item {
        // position: relative;

        > .item-name {
          font-size: 1rem;
          font-weight: 500;
          text-align: center;
          height: 60px;
          line-height: 60px;
          // width: 90px;
          // margin-right: 90px;
          color: var(--text-color);
          box-sizing: border-box;
          &.with-children {
            margin-right: 20px;
          }
        }
      }

      .nav-item.active > .item-name,
      .nav-item:hover > .item-name {
        position: relative;
        &::after {
          content: '';
          position: absolute;
          width: 45px;
          height: 4px;
          background: var(--primary-color);
          bottom: 0;
          left: calc(50%);
          transform: translateX(-50%);
        }

        color: var(--text-color);
      }

      .nav-second {
        display: none;
        z-index: 9999;
        position: absolute;
        top: 55px;
        left: 208px;
        &.products {
          // display: block;
          .nav-second-list {
            width: 1560px;
            .product-top {
              padding: 21px 0 38px;
              padding-right: 35px;
              display: flex;
              align-items: center;
              .left-title {
                font-size: 18px;
                font-weight: 600;
                width: 355px;
                padding-left: 26px;
              }
              .right-stage {
                width: 1134px;
                height: 58px;
                border-radius: 39px;
                background: #fff;
                box-shadow: 0 0 10px 0 rgba(8, 77, 218, 0.1);
                padding: 0 29px;
                .start {
                  margin-right: 5px;
                }
                .end {
                  margin-left: 8px;
                }
                .start,
                .end {
                  display: flex;
                  align-items: center;
                  color: #296fff;
                  font-size: 18px;
                  font-weight: 700;
                  i {
                    font-size: 14px;
                    margin-top: 4px;
                    margin-left: 7px;
                    color: rgba(68, 68, 68, 0.5);
                  }
                }
                .stage-item {
                  height: 100%;
                  padding: 0 12px 0 14px;
                  border-radius: 39px;
                  color: rgba(1, 13, 57, 1);
                  display: flex;
                  align-items: center;
                  font-size: 18px;
                  cursor: pointer;
                  &.active {
                    background: #1a65ff;
                    color: #fff;
                    i {
                      color: #fff;
                    }
                  }
                  i {
                    font-size: 14px;
                    margin-top: 4px;
                    margin-left: 7px;
                    color: rgba(68, 68, 68, 0.5);
                  }
                }
              }
            }
            .product-wrap {
              .product-left {
                width: 355px;
                position: relative;
                &::after {
                  content: '';
                  position: absolute;
                  right: 0;
                  top: 20px;
                  bottom: 50px;
                  width: 1px;
                  background: #C2CBD8;
                }
                .nav-third-item {
                  width: calc(100% - 15px);
                  padding-right: 5px;
                }
              }
              .product-right {
                width: 1094px;
                display: flex;
                padding-left: 15px;
                gap: 15px;
                .right-col {
                  width: 33%;
                  .nav-third-item {
                    width: 100%;
                  }
                }
                .right-col:first-child {
                  width: 37%;
                }
                .right-col:last-child {
                  width: 24%;
                }
              }
            }
          }
        }

        &.resources {
          // display: block;
          .nav-second-list {
            width: 1503px;
          }
        }

        &.company {
          .nav-second-list {
            width: 903px;
          }
        }

        .nav-second-content {
          .join {
            width: calc(100% - 26px);
            border-top: 1px solid #c2cbd8;
            padding: 20px 0 0;
            margin: 0 25px;
            font-weight: 500;
            .left-content {
              font-size: 16px;
            }
            img {
              width: 36px;
              margin-right: 20px;
            }
          }
          &.products {
            .join {
              width: calc(100% - 50px);
              margin-right: 25px;
            }
            .nav-second-wrap {
              .nav-third {
                padding-left: 16px;
              }
            }
          }
          &.solutions {
            padding: 0 40px 0 16px;
            .nav-second-wrap {
              margin-bottom: 26px;
              .nav-second-item {
                .item-name {
                  text-align: left;
                  padding-left: 26px;
                  font-size: 18px;
                  color: #010d39;
                  font-weight: 500;
                }
              }
            }
            .nav-second-wrap:first-child {
              width: 36%;
              padding-right: 24px;
              .nav-third {
                display: block;
                border-right: 1px solid #c2cbd8;
                padding-right: 24px;
                .nav-third-item {
                  width: 100%;
                  margin: 0;
                  margin-bottom: 20px;
                }
              }
            }
            .nav-second-wrap:last-child {
              width: 64%;
              .nav-third {
                gap: 20px;
                .nav-third-item {
                  width: calc(50% - 10px);
                  margin: 0;
                }
              }
            }
          }
          &.resources {
            .join {
              width: calc(100% - 100px);
              margin-right: 50px;
              margin-left: 50px;
            }
            .nav-second-wrap {
              padding-bottom: 38px;
              .nav-second-item .item-name {
                padding-left: 50px;
              }
              // .nav-third {
              //   .nav-third-item {
              //     .item-name {
              //       .text-wrap {
              //         .label {
              //           font-weight: normal;
              //         }
              //       }
              //     }
              //   }
              // }
            }
            .nav-second-wrap:first-child {
              width: 75%;
              .nav-third-wrap {
                gap: 20px;
                padding-left: 30px;
                padding-right: 25px;
                border-right: 1px solid #c2cbd8;
                .nav-third {
                  width: calc((100% - 40px) / 3);
                  display: block;
                  .nav-third-item {
                    width: 100%;
                    margin-bottom: 14px;
                    padding: 11px 0 10px 17px;
                    &:last-child {
                      margin-bottom: 0;
                    }
                  }
                }
              }
            }
            .nav-second-wrap:last-child {
              width: 25%;
              .nav-third-wrap {
                display: block;
                padding-left: 25px;
                .nav-third {
                  padding-right: 30px;
                  .nav-third-item {
                    width: 100%;
                  }
                }
              }
            }
          }
          &.company {
            .join {
              width: calc(100% - 100px);
              margin-right: 50px;
              margin-left: 50px;
            }
            .nav-second-wrap {
              .nav-second-item .item-name {
                padding-left: 50px;
              }
              .nav-third {
                gap: 10px;
                padding-left: 25px;
                padding-right: 30px;
                .nav-third-item {
                  width: calc((100% - 40px) / 2);
                }
              }
            }
          }
          .nav-second-wrap {
            width: 100%;
          }
        }

        .nav-second-list {
          width: 1222px;
          background-image: radial-gradient(circle at 0 0, #ebf0ff, #fff);
          border-radius: 6px;
          box-shadow: 0 14px 20px -6px #171f3d1c, 0 1px 2px #0000003d, 0 0 0 1px #1237693d;
          text-align: left;
          color: var(--text-color);
          padding: 18px 0;
        }

        .nav-second-list * {
          line-height: normal;
          font-size: 15px;

          img {
            vertical-align: middle;
          }
        }
      }

      .nav-item:hover .nav-second.with-children {
        display: block;
        /* 添加标准属性 */
        animation-name: fadeIn 0.25s forwards;
      }

      .nav-second-item {
        text-align: center;
        .item-name {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 25px;
          text-align: left;
          span {
            font-size: 18px;
          }
        }

        .nav-second-item-arrow {
          display: none;
        }
      }

      .nav-third {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        // padding-left: 45px;
        /* 添加标准属性 */
        animation-name: fadeIn;
        animation-duration: 0.25s;
        animation-iteration-count: 1;
        animation-delay: 0s;
      }

      .nav-third-item {
        width: 32.33%;
        margin-right: 1%;
        margin-bottom: 26px;
        padding: 21px 24px 24px;
        box-sizing: border-box;
        border-radius: 16px;
        color: var(--text-color);
        &.ml {
          margin-left: 50px;
          width: 26%;
        }
        &.long {
          width: 38%;
        }
        &.selected,
        &:hover {
          background: #dde4f4;
        }
        .arrow-wrap {
          width: 19px;
          .arrow {
            width: 19px;
          }
        }

        .item-name {
          cursor: pointer;
          transition: color 0.3s;
          img {
            width: 37px;
          }
          .text-wrap {
            margin: 0 10px;
            .label {
              font-size: 16px;
              font-weight: 500;
              &.special {
                width: 105%;
              }
            }
            .desc {
              margin-top: 8px;
              font-size: 12px;
              color: #4a5578;
            }
          }
        }

        .nav-third-item-children-item {
          font-size: 13px;
          margin-top: 10px;

          .item-name {
            font-size: 13px;
          }
        }

        .nav-third-item-children-item:hover {
          color: var(--primary-color);
        }
      }
    }
  }

  .nav-right {
    .loginBtn {
      font-size: 16px;
      width: 100px;
      text-align: center;
      height: 32px;
      line-height: 32px;
    }

    .el-dropdown {
      color: var(--text-color);
    }
  }
}
.drop_toggle {
  .item-name {
    position: relative;
  }
  i.el-icon-arrow-down {
    position: absolute;
    right: -20px;
    bottom: 35%;
    transition: all 0.3s;
    -webkit-transition: all 0.3s;
  }
  &.menu_arrow i.el-icon-arrow-down {
    -webkit-transform: rotateZ(180deg) !important;
    transform: rotateZ(180deg) !important;
  }
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover,
.el-dropdown-menu__item:has(.active) {
  background-color: #ecf5ff;
  color: var(--primary-color);
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    /*初始状态 透明度为0*/
  }

  20% {
    opacity: 0.2;
  }

  50% {
    opacity: 0.5;
    /*中间状态 透明度为0.5*/
  }

  70% {
    opacity: 0.7;
  }

  100% {
    opacity: 1;
    /*结尾状态 透明度为1*/
  }
}
.nav-list-mobile {
  display: none;
  float: right;
  .icon-wrap {
    .menu {
      width: 70px;
    }
    .menu-off {
      width: 70px;
    }
  }
}
.mobile-menu {
  width: 100vw;
  position: absolute;
  top: 200px;
  right: 0;
  left: 0;
  bottom: 0;
  background: #fff;
  padding: 3rem 0;
  padding-bottom: 180px;
  height: calc(100vh - 200px);
  overflow-y: auto;
  z-index: 999999;
  .nav-item {
    .item-name {
      font-size: 80px;
      padding: 75px 3rem;
      border-bottom: 1px solid #f1f1f1;
    }
  }
  .nav-second-item {
    padding-right: 50px;
    border-bottom: 1px solid #f1f1f1;
    & > div {
      width: 100%;
    }
    .nav-second-item-arrow {
      font-size: 66px;
    }
    .item-name {
      text-indent: 1em;
      width: 100%;
      border: none;
    }
  }
  .nav-third-item {
    width: 100% !important;
    background: #f9ffff;
    .item-name {
      text-indent: 2em;
    }
  }
}
</style>
